export function formatViewToK(views) {
  return (
    (views / 1000).toLocaleString("en", {
      minimumFractionDigits: 1,
    }) + "K"
  );
}
